import { render, staticRenderFns } from "./NewPayment.vue?vue&type=template&id=0f5a52bc"
import script from "./NewPayment.vue?vue&type=script&lang=js"
export * from "./NewPayment.vue?vue&type=script&lang=js"
import style0 from "./NewPayment.vue?vue&type=style&index=0&id=0f5a52bc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports